import { validateNumber, validateString } from 'avilatek-utils';
import { validateOperatorCode } from '../../static';

export function validatePagoMovilForm({
  reference,
  bank,
  date,
  dnitype,
  dni,
  phone,
  amount,
}: any): string {
  if (!validateOperatorCode(phone)) {
    return 'Debes ingresar el número de teléfono valido (424, 414, 412, 416)';
  }
  if (!validateString(phone) || phone.length < 11) {
    return 'El numero de teléfono debe tener 11 dígitos';
  }
  if (!validateString(dni) || dni.length < 6) {
    return 'Debes ingresar un número de cédula válido';
  }
  if (!validateString(reference) || reference === '' || reference.length < 4) {
    return 'Debes ingresar el número de referencia (mínimo 4 dígitos)';
  }
  if (!validateString(date) || date === '') {
    return 'Debes ingresar la fecha del pago';
  }
  if (new Date(date) > new Date()) {
    return 'La fecha no puede ser mayor a la fecha actual';
  }
  if (!validateString(bank) || bank === '') {
    return 'Debes seleccionar un banco';
  }
  if (!validateNumber(amount) && amount <= 0) {
    return 'Debes ingresar un monto válido';
  }

  return '';
}
